import { Box, ButtonGroup } from "@material-ui/core";
import { RotateLeft } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useNotify, useRefresh } from "react-admin";
import { DetailButton } from "../../../../../../Components/DetailButton";
import { useAppDataProvider } from "../../../../../../dataprovider";
import { EightWingsStatus } from "../../../../../../Enums/EightWingsTabEnum";
import AcceptIconButton from "../../../../../../Components/AcceptButton/AcceptIconButton";

export const Actions = props => {
  const [isShowTTVerifyButton, setIsShowTTVerifyButton] = useState(false);
  var dataProvider = useAppDataProvider();
  const refresh = useRefresh();
  const notify = useNotify();
  useEffect(() => {
    getHistoryForWaitingTTVerify();
  }, []);
  const handleTTAgain = () => {
    dataProvider
      .post("eightwings/updatestatus", { id: props?.record?.id, status: EightWingsStatus.WaitingTTVerify })
      .then(result => {
        props?.finalCallBack?.();
        props.reloadTabs();
        notify(`Record verified`, "success", false, true);
        refresh();
      })
      .catch(result => notify(`${result}`, "error", false, true));
  };

  const getHistoryForWaitingTTVerify = async () => {
    dataProvider
      .getList("EightWingsRequestOrderHistorys", {
        pagination: { page: 1, perPage: 1 },
        sort: { field: "id", order: "DESC" },
        filter: { requestStatus__eq: EightWingsStatus.WaitingTTVerify, requestId__eq: props?.record?.id },
      })
      .then(response => {
        if (response.data?.length > 0) {
          setIsShowTTVerifyButton(true);
        } else {
          setIsShowTTVerifyButton(false);
        }
      })
      .catch(error => {});
  };
  return (
    <Box style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", gap: "8px" }}>
      <ButtonGroup variant="text" size="small">
        <DetailButton {...props} path={"eightwings"} />
        {isShowTTVerifyButton && (
          <AcceptIconButton
            {...props}
            tooltip={"Send to TT again"}
            content={"Do you want to put the record to 'Waiting TT User' status?"}
            resource={"eightwings/updatestatus"}
            icon={<RotateLeft />}
            onClick={handleTTAgain}
          />
        )}
      </ButtonGroup>
    </Box>
  );
};
export default Actions;
